import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import { RoleServicesService } from '../../services/role-services.service';
import { saveAs } from 'file-saver';
import { FormControl, FormGroup } from '@angular/forms';
import { SharedServicesService } from '../../services/shared-services.service';
import { GlobalServicesService } from 'src/app/services/global-services.service';
import { BreadcrumbService   } from 'xng-breadcrumb';
import { SettingsService } from 'src/app/services/settings.service';
import { EventServicesService } from 'src/app/services/event-services.service';
import { Router } from '@angular/router';
import { ViewPreferencesCacheService, ViewPreferences } from 'src/app/services/view-preferences-cache.service';
import { Subscription } from 'rxjs';
@Component({
    selector: 'app-role-list',
    templateUrl: './role-list.component.html',
    styleUrls: ['./role-list.component.css'],
    providers: [MessageService],
    standalone: false
})
export class RoleListComponent implements OnInit, OnDestroy {
  showAddRole: boolean = false;
  rowData: any = null;
  roleList: Array<any> = [];
  pageLimits: Array<any> = [];
  status: MenuItem[] = [];
  selectedRoles: Array<any> = [];
  rolesCol: Array<any> = [];
  __rolesCol: Array<any> = [];
  _selectedColumns: any[] = [];
  colsToDownload: Array<any> = [];
  roleOptions: Array<any> = [];
  eventRole: object = {};
  filteredRoleList: Array<any> = [];
  columnsToSave: Array<any> = [];
  savedColumnSettings: Array<any> = [];
  userPrivileges: Set<string> = new Set();
  showViewRoleSidebar: boolean = false;

  //Filtering Array
  checkedColumns: Array<any> = [];
  selectedStatusElements: Array<any> = [];
  selectedRoleTypeElements: Array<any> = [];
  selectedDepartmentElements: Array<any> = [];
  currentFilter: any = {
    type: 'All',
    label: 'All'
  };
  // Boolean Var
  addRolesSlider: boolean = false;
  loadingSpinner: boolean = false;
  showFilterSidebar: boolean = false;
  showSettingsSidebar: boolean = false;
  showDownloadSidebar: boolean = false;
  displaySaveFilterSettings: boolean = false;
  displaySaveColumnSettings: boolean = false;

  // Number Var
  first: number = 1;
  last: number = 10;
  pageSize: number = 25;
  pageNumber: number = 1;
  totalLength: number = 0;
  totalPages: number = 1;
  selectAllColumns: boolean = false;
  loadingDownload: boolean = false;

  // String var
  order_by: string = 'desc';
  sort_by: string = 'id';
  statusSelected: string = 'All';
  statusLabel: string = 'All';
  columnSearchTerm: string = '';
  filterSearchTerm: string = '';
  downloadSearchTerm: string = '';
  columnFieldId: string = '';
  downloadAs: string = 'excel';
  exportName: string = 'roleList';
  privilege: any = {};
  skeletonData: any[] = Array(10).fill({}).map((_, index) => ({
    id: `skeleton-${index}`,
    name: '',
    role_type: '',
    work_mode: '',
    location: [''],
    opening: [''],
    department: '',
    status: '',
    created_at: '',
    description: '',
    requirement: ''
  }));

  constructor(
    private eventServices: EventServicesService,
    private roleService: RoleServicesService,
    private messageService: MessageService,
    private _sharedService: SharedServicesService,
    private globalService: GlobalServicesService,
    private breadcrumbService: BreadcrumbService,
    private router: Router,
    private viewPreferencesCache: ViewPreferencesCacheService
  ) {
    this.pageLimits = [10, 25, 50, 100];

    this.rolesCol = [
      // { index: 1, field: 'id', header: 'ROLE ID' },
      { index: 2, field: 'role_type', header: 'ROLE TYPE' },
      { index: 3, field: 'work_mode', header: 'WORK MODE' },
      { index: 4, field: 'location', header: 'LOCATION' },
      { index: 5, field: 'opening', header: 'OPENINGS' },
      // { index: 6, field: 'hiring_manager', header: 'Hiring manager' }
    ];

    this._selectedColumns = [
      // { index: 1, field: 'id', header: 'ROLE ID' },
      { index: 2, field: 'role_type', header: 'ROLE TYPE' },
      { index: 3, field: 'work_mode', header: 'WORK MODE' },
      { index: 4, field: 'location', header: 'LOCATION' },
      { index: 5, field: 'opening', header: 'OPENINGS' },
      // { index: 6, field: 'hiring_manager', header: 'Hiring manager' }
    ];

    this.roleOptions = [
      {
        label: 'Delete',
        icon: 'pi pi-times',
        command: () => {
          this.deleteRole(this.eventRole);
        },
      },
    ];
  }

  columnSettings: FormGroup = new FormGroup({
    name: new FormControl(''),
    saved_columns: new FormControl(this.columnsToSave),
  });

  ngOnInit(): void {
    this.globalService.privilegeDetailsSubject.subscribe((privileges) => {
      this.userPrivileges = privileges;
    });    
    
    this.loadCachedPreferences();
    
    if (this.userPrivileges.has('job_role.view')) {
      this.getAllRoles(this.statusSelected);
      this.getSavedColumns();
    }
    this.__rolesCol = this.rolesCol;
    this.colsToDownload = this.rolesCol;
    this.checkedColumns = this._selectedColumns;
    this.selectAllColumns = this.checkedColumns.length === this.colsToDownload.length;
    this._sharedService.emitChange('');
    this.privilege = this.globalService.privilegeDetails;
    this.updateBreadcrumb();
  
    this.globalService.searchList.subscribe((response) => {
      this.pageNumber = 1
      if (response && response.items) {
        this.roleList = response.items || [];
        this.roleList.forEach((each) => {
          each.location = [];
          each.opening = [];
          each.locations.forEach((eachLocation: any) => {
            each.location.push(`${eachLocation.city}`);
            each.opening.push(`${eachLocation.opening}`);
          });
          each.role_type = each.role_type.name;
        });
        this.totalLength = response.total || 0;
        this.first = response.page || 1;
        this.last = response.pages || 10;
        this.pageSize = response.size || 10;
        this.totalPages = response.pages || 1;
        this.loadingSpinner = false;
      }
    });
  }

  updateBreadcrumb(): void {
    this.breadcrumbService.set('@jobRoles', 'Manage Job Roles');
  }
  
  onCloseAddRole(success: boolean) {
    this.showAddRole = false;
    if (success && this.userPrivileges.has('job_role.view')) {
      this.getAllRoles(this.statusSelected);
    }
  }

  getAllRoles = (filterValue?: any) => {
    this.loadingSpinner = true;
    this.roleList = [];
    const filter = filterValue || this.currentFilter.type;
    this.roleService.getJobRolesFastApi(this.pageNumber, this.pageSize, this.order_by, this.sort_by, '',filter,).subscribe({
      next: (response: any) => {
        this.roleList = Object.keys(response.body.items).length !== 0 ? response.body.items : [];
        this.roleList.forEach((each) => {
          each.location = [];
          // each.hiring_manager = [];
          each.opening = [];
          each.locations.forEach((eachLocation: any) => {
            each.location.push(`${eachLocation.city}`);
            // each.hiring_manager.push(`${eachLocation.hire_manager.first_name} ${eachLocation.hire_manager.last_name}`);
            each.opening.push(`${eachLocation.opening}`);
          });

          each.role_type = each.role_type.name;

        });
        this.totalLength = response.body.total || 0;
        this.first = response.body.page || 1;
        this.last = response.body.pages || 10;
        this.pageSize = response.body.size || 10;
        this.totalPages = response.body.pages || 1;
        this.loadingSpinner = false;
      },
      error: () => {
        this.loadingSpinner = false;
      }
    });
  };

  deleteRole = (role: any) => {
    this.loadingSpinner = true;
    this.roleService.deleteJobRolesFastApi(role.id.toString()).subscribe({
      next: (res) => {
        if (res.status === 200) {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: res.body.detail
          });
          this.selectedRoles = [];
          if (this.userPrivileges.has('job_role.view')) {
            this.getAllRoles(this.statusSelected);
          }
        }
        this.loadingSpinner = false;
      },
      error: () => {
        this.loadingSpinner = false;
      }
    });
  };

  saveColumnSettings = () => {
    this.loadingSpinner = true;
    this.columnsToSave = this.checkedColumnsBackup.map(e => e.field);

    this.columnSettings.setValue({
      name: this.columnSettings.get("name")?.value,
      saved_columns: this.columnsToSave
    });

    this.eventServices.saveUserPreferencesFastApi(this.columnSettings.value, 'job_role').subscribe({
      next: (result: any) => {
        this.getSavedColumns();
        this.loadingSpinner = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: result.body.detail,
        });
        this.clearColumnPreferenceName();
      },
      error: () => {
        this.loadingSpinner = false;
        this.clearColumnPreferenceName();
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: "unable to save user preferences",
        });
      }
    });
    this.clearColumnPreferenceName();
  };

  // getColumnId = () => {
  //   this.roleService.getSchool().subscribe((res) => {
  //     this.columnFieldId = res.data[0].id;
  //   });
  // };

  getSavedColumns = () => {
    this.eventServices.getUserPreferencesFastApi('job_role').subscribe(res => {
      this.savedColumnSettings = res.body.user_preferences ? res.body.user_preferences : [];
      
      // Store dynamic role types for filter tabs
      this.dynamicRoleTypes = res.body.filters.role_types || [];
      
      this.status = [
        {
          label: 'All',
          command: () => {
            this.statusLabel = 'All';
            this.getRolesByFilter('All');
          }
        },
        ...this.dynamicRoleTypes.map((item: any) => ({
          label: item.name,
          command: () => {
            this.statusLabel = item.name;
            this.getRolesByFilter(item.id);
          }
        }))
      ];
    });
  }

  deleteSavedColumns = (columnId: string) => {
    this.loadingSpinner = true;
    this.eventServices.deleteUserPreferencesFastApi(columnId).subscribe({
      next: res => {
        this.getSavedColumns();
        this.loadingSpinner = false;
      },
      error: () => {
        this.loadingSpinner = false;
      }
    });
  }

  getEventVal = (event: Event) => {
    return (event.target as HTMLInputElement).value;
  };

  onSelectedRoleChange = (value: []) => {
    this.selectedRoles = value;
  };

  // For data export
  exportRole = (fileType?: string) => {
    let checkedColumnFields = ['name'];
    this.checkedColumns.forEach((each) => {
      checkedColumnFields.push(each.field);
    });

    const dataToExport = this.selectedRoles.length > 0 ? this.selectedRoles : this.roleList;
    let exportData: any = [];
    dataToExport.forEach((role: any) => {
      let filterData: any = {};
      checkedColumnFields.forEach((field: string) => {
        if (role.hasOwnProperty(field)) {
          switch (field) {
            case 'location':
              filterData[field] = role.locations
                .map((loc: any) => `${loc.city[0]}, ${loc.state}, ${loc.country}`)
                .join('; ');
              break;
            // case 'hiring_manager':
            //   filterData[field] = role.locations
            //     .map((loc: any) => `${loc.hire_manager.first_name} ${loc.hire_manager.last_name}`)
            //     .join('; ');
            //   break;
            case 'opening':
              filterData[field] = role.locations
                .map((loc: any) => `${loc.opening}`)
                .join('; ');
              break;
            default:
              filterData[field] = role[field];
          }
        }
      });
      exportData.push(filterData);
    });

    this.saveAsExcelFile(exportData, this.exportName, fileType);
  };

  saveAsExcelFile(data: any, fileName: string, type?: string): void {
    if (type === "csv") {
      const headers = Object.keys(data[0]).join(",");
      const rows = data
        .map((obj: any) =>
          Object.values(obj)
            .map(value => this.escapeCSVValue(value))
            .join(",")
        )
        .join("\n");
      const csvContent = `${headers}\n${rows}`;
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      saveAs(blob, `${fileName}_export_${new Date().getTime()}.csv`);
      this.showDownloadSidebar = false;
      this.resetCheckedColumnsToDefault();
    } else {
      import("xlsx").then(XLSX => {
        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Roles");
        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
        saveAs(blob, `${fileName}_export_${new Date().getTime()}.xlsx`);
        this.showDownloadSidebar = false;
        this.resetCheckedColumnsToDefault();
      });
    }
  }

  private escapeCSVValue(value: any): string {
    if (typeof value === "string" && value.includes(",")) {
      return `"${value.replace(/"/g, '""')}"`;
    }
    return value;
  }

  applySelectedColumns = () => {
    this.checkedColumns = this.checkedColumnsBackup;
    this._selectedColumns = this.sortedColumns();
    this.showSettingsSidebar = false;
  };

  clearSelectedColumns = () => {
    this.checkedColumns = [];
  };

  applySelectedFilter = () => {
    if (
      this.selectedStatusElements.length ||
      this.selectedRoleTypeElements.length ||
      this.selectedDepartmentElements.length
    ) {
      this.filteredRoleList = [];

      let statusFilter = this.roleList.filter((element) =>
        this.selectedStatusElements.includes(element.status)
      );
      let roleTypeFilter = this.roleList.filter((element) =>
        this.selectedRoleTypeElements.includes(element.role_type)
      );
      let departmentFilter = this.roleList.filter((element) =>
        this.selectedDepartmentElements.includes(element.department)
      );

      this.filteredRoleList = [
        ...new Set([...statusFilter, ...roleTypeFilter, ...departmentFilter]),
      ];
      this.showFilterSidebar = false;
    } else {
      this.filteredRoleList = [];
    }
  };

  clearSelectedFilters = () => {
    this.selectedStatusElements = [];
    this.selectedRoleTypeElements = [];
    this.selectedDepartmentElements = [];
  };

  applySavedSettings = (savedColumnValue: Array<any>) => {
    this.checkedColumnsBackup = this.rolesCol.filter(e => savedColumnValue.includes(e.field));
    this.checkedColumnsFields = this.checkedColumnsBackup.map((col) => col.field);
  }

  openRoleDetails(role: any) {
    this.router.navigate(["/roles", role.id])
  }
  
  onEditRole() {
    this.showViewRoleSidebar = false;    
    const editData = JSON.parse(JSON.stringify(this.rowData));
    editData.isUpdate = true;    
    setTimeout(() => {
      this.rowData = editData;
      this.showAddRole = true;
    }, 100);
  }
  collapsedSections: { [key: string]: boolean } = {
    info: true,
    locations: true,
    diversity: true
  };
  
  toggleSection(section: string) {
    this.collapsedSections[section] = !this.collapsedSections[section];
  }
  previewAttachment(url: string): void {
    if (url) {
      window.open(url, '_blank');
    }
  }  
  downloadAttachment(url: string): void {
    if (url) {
      const link = document.createElement('a');
      link.href = url;
      link.download = url.split('/').pop() || 'attachment';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
  getRolesByLimit = () => {
    this.showFilterSidebar = false;
    this.showSettingsSidebar = false;
    this.showDownloadSidebar = false;
    this.pageNumber = 1;
    this.first = 1;
    this.last = this.pageSize < this.totalLength ? this.pageSize : this.totalLength;
    
    this.saveCurrentPreferences();
    
    this.getAllRoles(this.statusSelected);
  };

  searchColumns = (searchTerm: string) => {
    if (this.showSettingsSidebar) {
      this.__rolesCol = this.rolesCol.filter((val) =>
        val.header.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    if (this.showDownloadSidebar) {
      this.colsToDownload = this.rolesCol.filter((val) =>
        val.header.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
  };

  // get roles by filter
  getRolesByFilter = (id: any) => {
    this.statusSelected = id;
    this.currentFilter = {
      type: id,
      label: this.statusLabel
    };
    this.pageNumber = 1;
    this.first = 1;
    this.last =
      this.pageSize < this.totalLength ? this.pageSize : this.totalLength;
    
   
    this.saveCurrentPreferences();
    
    this.getAllRoles(this.currentFilter.type);
  };

  private sortedColumns(): any[] {
    return this.checkedColumns.sort((a, b) => (a.index < b.index ? -1 : 1));
  }

  // For custom pagination
  next(): void {
    this.showFilterSidebar = false;
    this.showSettingsSidebar = false;
    this.showDownloadSidebar = false;
    this.selectedRoles = [];
    this.first = this.first + this.pageSize;
    this.last =
      this.last + this.pageSize < this.totalLength
        ? this.pageSize + this.last
        : this.totalLength;
    this.pageNumber += 1;
    
   
    this.saveCurrentPreferences();
    
    const currentFilter = this.currentFilter?.type || this.statusSelected || 'All';
    this.getAllRoles(currentFilter);
  }
  
  prev(): void {
    this.showFilterSidebar = false;
    this.showSettingsSidebar = false;
    this.showDownloadSidebar = false;
    this.selectedRoles = [];
    this.first = this.first - this.pageSize;
    this.last = this.last - this.pageSize > this.pageSize ? (this.last == this.totalLength ? this.totalLength - this.roleList.length : this.last - this.pageSize) : this.pageSize;
    this.pageNumber -= 1;
    
    
    this.saveCurrentPreferences();
    
    const currentFilter = this.currentFilter?.type || this.statusSelected || 'All';
    this.getAllRoles(currentFilter);
  }

  isLastPage(): boolean {
    return this.pageNumber === this.totalPages;;
  }

  isFirstPage(): boolean {
    return this.first === 1;
  }

  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
    this._selectedColumns = this.rolesCol.filter((col) => val.includes(col));
  }

  getHeaderVal(col: string) {
    let result = col.replace(/([A-Z])/g, ' $1');
    return result.charAt(0).toUpperCase() + result.slice(1);
  }

  setEventRoleId(role: any) {
    this.eventRole = role;
  }
  onSort(event: any) {
    if (this.sort_by !== event.field || this.order_by !== (event.order === 1 ? 'asc' : 'desc')) {
      this.sort_by = event.field;
      this.order_by = event.order === 1 ? 'asc' : 'desc';
      this.getAllRoles(this.statusSelected);
    }
  }
  copyToClipboard(text: string, label: string): void {
    if (!text) return;
    
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text.toString()).then(() => {
        this.messageService.add({
          severity: 'success',
          summary: 'Copied!',
          detail: `${label} copied to clipboard`,
          life: 2000
        });
      }).catch((err) => {
        console.error('Clipboard API failed:', err);
        this.fallbackCopyToClipboard(text.toString(), label);
      });
    } else {
      this.fallbackCopyToClipboard(text.toString(), label);
    }
  }
  
  private fallbackCopyToClipboard(text: string, label: string): void {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    
    try {
      const successful = document.execCommand('copy');
      if (successful) {
        this.messageService.add({
          severity: 'success',
          summary: 'Copied!',
          detail: `${label} copied to clipboard`,
          life: 2000
        });
      } else {
        this.messageService.add({
          severity: 'warn',
          summary: 'Copy Failed',
          detail: 'Please copy manually: ' + text,
          life: 3000
        });
      }
    } catch (err) {
      console.error('Fallback copy failed:', err);
      this.messageService.add({
        severity: 'error',
        summary: 'Copy Failed',
        detail: 'Please copy manually: ' + text,
        life: 3000
      });
    } finally {
      document.body.removeChild(textArea);
    }
  }
setStatus(status: string) {
  this.statusLabel = status;
}

  dynamicRoleTypes: any[] = [];

  // Cache service properties
  private readonly CACHE_ROUTE_KEY = 'roles-list';
  private cacheSubscription: Subscription = new Subscription();

getWorkModeClass(workMode: string): string {
  if (!workMode) return '';
  
  const mode = workMode.toLowerCase();
  switch (mode) {
    case 'remote':
      return 'work-mode-remote';
    case 'onsite':
      return 'work-mode-onsite';
    case 'hybrid':
      return 'work-mode-hybrid';
    default:
      return '';
  }
}

getLocationTooltip(locations: any[]): string {
  if (!locations || locations.length <= 1) return '';
  
  const remainingLocations = locations.slice(1);
  const tooltipContent = remainingLocations.map((location, index) => 
    `<div class="tooltip-item">${location || '-'}</div>`
  ).join('');
  
  return `<div class="tooltip-content">${tooltipContent}</div>`;
}

toggleSelectAll() {
  if (this.selectAllColumns) {
    this.checkedColumns = [...this.colsToDownload];
  } else {
    this.checkedColumns = [...this._selectedColumns];
  }
  this.selectAllColumns = this.checkedColumns.length === this.colsToDownload.length;
}

onColumnCheckChange() {
  this.selectAllColumns = this.checkedColumns.length === this.colsToDownload.length;
}

exportAllRoles(format: string) {
  this.exportRole(format);
}


getWorkModeColor(workMode: string): string {
  if (!workMode) return '#f3f4f6'; 

  const workModeColors: { [key: string]: { bg: string, text: string } } = {
    'remote': { bg: '#f0fdf4', text: '#16a34a' },
    'onsite': { bg: '#eff6ff', text: '#2563eb' },
    'hybrid': { bg: '#fff7ed', text: '#ea580c' },
    'freelance': { bg: '#f3e8ff', text: '#7c3aed' },
    'contract': { bg: '#fef3c7', text: '#d97706' },
    'parttime': { bg: '#ecfdf5', text: '#059669' },
    'fulltime': { bg: '#dbeafe', text: '#1e40af' }
  };

  const normalizedMode = workMode.toLowerCase().replace(/[-_\s]/g, '');
  
  if (workModeColors[normalizedMode]) {
    return workModeColors[normalizedMode].bg;
  }

  let hash = 0;
  for (let i = 0; i < workMode.length; i++) {
    hash = workMode.charCodeAt(i) + ((hash << 5) - hash);
  }
  
  const hue = Math.abs(hash) % 360;
  return `hsl(${hue}, 65%, 95%)`;
}

getWorkModeTextColor(workMode: string): string {
  if (!workMode) return '#6b7280';

  const workModeColors: { [key: string]: { bg: string, text: string } } = {
    'remote': { bg: '#f0fdf4', text: '#16a34a' },
    'onsite': { bg: '#eff6ff', text: '#2563eb' },
    'hybrid': { bg: '#fff7ed', text: '#ea580c' },
    'freelance': { bg: '#f3e8ff', text: '#7c3aed' },
    'contract': { bg: '#fef3c7', text: '#d97706' },
    'parttime': { bg: '#ecfdf5', text: '#059669' },
    'fulltime': { bg: '#dbeafe', text: '#1e40af' }
  };

  const normalizedMode = workMode.toLowerCase().replace(/[-_\s]/g, '');
  
  if (workModeColors[normalizedMode]) {
    return workModeColors[normalizedMode].text;
  }

  let hash = 0;
  for (let i = 0; i < workMode.length; i++) {
    hash = workMode.charCodeAt(i) + ((hash << 5) - hash);
  }
  
  const hue = Math.abs(hash) % 360;
  return `hsl(${hue}, 70%, 45%)`;
}

calculateTotalOpenings(openings: string[]): number {
  if (!openings || !Array.isArray(openings)) return 0;
  return openings.reduce((sum, opening) => sum + (parseInt(opening) || 0), 0);
}
clearColumnPreferenceName(): void {
  this.columnSettings.get('name')?.setValue('');
  this.displaySaveColumnSettings = false;
}

resetCheckedColumnsToDefault(): void {
  this.checkedColumns = [...this._selectedColumns];
  this.selectAllColumns = this.checkedColumns.length === this.colsToDownload.length;
}


private loadCachedPreferences(): void {
  const defaultPreferences: ViewPreferences = {
    pageSize: 25,
    pageNumber: 1,
    statusFilter: 'All',
    searchTerm: '',
    sortBy: 'id',
    orderBy: 'desc',
    selectedColumns: this._selectedColumns
  };

  const cachedPreferences = this.viewPreferencesCache.getPreferencesWithDefaults(
    this.CACHE_ROUTE_KEY, 
    defaultPreferences
  );

  if (cachedPreferences) {
    this.pageSize = cachedPreferences.pageSize || 25;
    this.pageNumber = cachedPreferences.pageNumber || 1;
    this.statusSelected = cachedPreferences.statusFilter || 'All';
    this.statusLabel = cachedPreferences.statusFilter || 'All';
    this.sort_by = cachedPreferences.sortBy || 'id';
    this.order_by = cachedPreferences.orderBy || 'desc';
    
    if (cachedPreferences.selectedColumns && cachedPreferences.selectedColumns.length > 0) {
      this._selectedColumns = cachedPreferences.selectedColumns;
      this.checkedColumns = [...this._selectedColumns];
    }

   
    this.first = ((this.pageNumber - 1) * this.pageSize) + 1;
    this.last = Math.min(this.pageNumber * this.pageSize, this.totalLength);
  } else {
   
    this.pageSize = 25;
    this.pageNumber = 1;
    this.statusSelected = 'All';
    this.statusLabel = 'All';
    this.first = 1;
    this.last = this.pageSize;
  }
}


private saveCurrentPreferences(): void {
  const preferences: ViewPreferences = {
    pageSize: this.pageSize,
    pageNumber: this.pageNumber,
    statusFilter: this.statusSelected,
    searchTerm: '',
    sortBy: this.sort_by,
    orderBy: this.order_by,
    selectedColumns: this._selectedColumns
  };

  this.viewPreferencesCache.savePreferences(this.CACHE_ROUTE_KEY, preferences);
}

refreshTable(): void {
  this.viewPreferencesCache.clearCacheOnRefresh();
  
  this.pageSize = 25;
  this.pageNumber = 1;
  this.statusSelected = 'All';
  this.statusLabel = 'All';
  this.first = 1;
  this.last = this.pageSize;
  
  this.getAllRoles('All');
}

ngOnDestroy(): void {
  this.saveCurrentPreferences();
  
  this.cacheSubscription.unsubscribe();
}

checkedColumnsFields: string[] = [];
checkedColumnsBackup: any[] = [];
updatedSelectedColFields() {
  this.checkedColumnsBackup = JSON.parse(JSON.stringify(this.checkedColumns));
  this.checkedColumnsFields = this.checkedColumnsBackup.map((col) => col.field);
}

updateCheckedColumns(event: any) {
  this.checkedColumnsFields = event;
  this.checkedColumnsBackup = this.rolesCol.filter((col) => event.includes(col.field))
}
}
